import { showUpdateTokenOriginState } from '@/atoms';
import { useUpdateTokenOrigin } from '@/services/tokens';
import { Button, Group, Input, InputLabel, Text } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { ModalLayout } from 'moh-ui';
import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useRecoilState } from 'recoil-next';

export default function UpdateTokenOriginModal() {
   const [show, setShow] = useRecoilState(showUpdateTokenOriginState);
   const [origin, setOrigin] = useState('');
   const [error, setError] = useState('');
   const queryClient = useQueryClient();
   const { mutate: updateOrigin, isLoading } = useUpdateTokenOrigin();

   useEffect(() => {
      if (show?.token) {
         setOrigin(show.token.origin);
      }
   }, [show]);

   const handleClose = () => {
      setShow(null);
      setOrigin('');
      setError('');
   };

   const handleSubmit = (e: React.FormEvent) => {
      e.preventDefault();
      if (!origin.trim()) {
         setError('Origin is required');
         return;
      }

      if (show?.token) {
         updateOrigin(
            { tokenId: show.token.id, body: { newOrigin: origin } },
            {
               onSuccess: () => {
                  queryClient.invalidateQueries('tokens');
                  showNotification({
                     title: 'Success',
                     message: 'Origin updated successfully',
                     color: 'green',
                  });
                  handleClose();
               },
               onError: (error) => {
                  showNotification({
                     title: 'Error',
                     message: error.message || 'Failed to update origin',
                     color: 'red',
                  });
               },
            },
         );
      }
   };

   return (
      <ModalLayout open={Boolean(show?.show)} onClose={handleClose} size="md">
         <h2 className="text-xl font-semibold">Update Token Origin</h2>
         <form onSubmit={handleSubmit} className="space-y-4 mt-4">
            <div className="space-y-2">
               <InputLabel required>New Origin</InputLabel>
               <Input
                  value={origin}
                  onChange={(e) => {
                     setOrigin(e.target.value);
                     setError('');
                  }}
                  placeholder="Enter new origin"
                  disabled={isLoading}
                  error={error}
               />
               {error && (
                  <Text color="red" size="sm">
                     {error}
                  </Text>
               )}
            </div>
            <Group mt="md">
               <Button variant="outline" onClick={handleClose} disabled={isLoading}>
                  Cancel
               </Button>
               <Button type="submit" loading={isLoading}>
                  Update Origin
               </Button>
            </Group>
         </form>
      </ModalLayout>
   );
}
